module.exports = __webpack_public_path__ + "static/media/yellow-small.54da92d1.svg";